package com.patronat.top.features.usermanagement.domain.usecase.command

import com.patronat.top.core.domain.models.profiles.User

data class CreateUserCommand(
    val user: User,
)